import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["frequency", "recurrenceFields", "bydayRow"];

  connect() {
    this.frequencyChanged();
  }

  frequencyChanged() {
    const freq = this.frequencyTarget.value;
    const show = freq !== "none" && freq !== "";
    this.recurrenceFieldsTarget.style.display = show ? "" : "none";
    if (this.hasBydayRowTarget) {
      this.bydayRowTarget.style.display = freq === "WEEKLY" ? "" : "none";
    }
  }
}
